// Fairway Lab brand mark — a white "F" stylized as a golf flag on a navy square.
export default function Logo({ size = 36, className = "" }) {
  return (
    <div
      className={`relative inline-flex items-center justify-center rounded-xl ${className}`}
      style={{
        width: size,
        height: size,
        background: "#0B2545",
      }}
      data-testid="brand-logo"
    >
      <svg viewBox="0 0 24 24" width={size * 0.62} height={size * 0.62} aria-label="Fairway Lab">
        {/* Flagstick / vertical spine of F */}
        <rect x="6.5" y="3" width="2.4" height="18" rx="0.6" fill="#FFFFFF" />
        {/* Top bar shaped as a triangular pennant */}
        <path d="M8.9 3 L19 3 L14.5 7 L8.9 7 Z" fill="#FFFFFF" />
        {/* Middle bar shaped as a smaller pennant */}
        <path d="M8.9 9.8 L15.6 9.8 L12.4 13.4 L8.9 13.4 Z" fill="#FFFFFF" />
        {/* Small base under the flagstick */}
        <rect x="4.7" y="20" width="6" height="1.6" rx="0.6" fill="#FFFFFF" />
      </svg>
    </div>
  );
}
